// from https://github.com/sindresorhus/multi-download
'use strict';
import { bulkDownloadS3File } from '../stores/actions';
// takes an array of objs containing url and fileName:
// [{
//   url,
//   fileName,
// }]

function fallback(urls) {
  var i = 0;

	(function createIframe() {
		var frame = document.createElement('iframe');
		frame.style.display = 'none';
		frame.src = urls[i++];
		document.documentElement.appendChild(frame);

		// the download init has to be sequential otherwise IE only use the first
		var interval = setInterval(function () {
			if (frame.contentWindow.document.readyState === 'complete'
			|| frame.contentWindow.document.readyState === 'interactive') {
				clearInterval(interval);

				// Safari needs a timeout
				setTimeout(function () {
					frame.parentNode.removeChild(frame);
				}, 1000);

				if (i < urls.length) {
					createIframe();
				}
			}
		}, 100);
	})();
}

function isFirefox() {
	// sad panda :(
	return /Firefox\//i.test(navigator.userAgent);
}

function sameDomain(url) {
	var a = document.createElement('a');
	a.href = url;

	return location.hostname === a.hostname && location.protocol === a.protocol;
}

function download(file) {
	var a = document.createElement('a');
	a.download = file.fileName || '';
  a.setAttribute('download', file.fileName);
	a.href = `/proxy/s3/file?key=${encodeURIComponent(file.url)}`;
	// firefox doesn't support `a.click()`...
	a.dispatchEvent(new MouseEvent('click'));
}

module.exports = {
  multiDownload(files) {
    if (!files) {
  		throw new Error('`files` required');
  	}
    bulkDownloadS3File(files, 'bulkDownload');
  	// if (typeof document.createElement('a').download === 'undefined') {
  	// 	return fallback(files);
  	// }
    //
  	// var delay = 0;
    //
  	// files.forEach(file => {
  	// 	// the download init has to be sequential for firefox if the urls are not on the same domain
  	// 	if (isFirefox() && !sameDomain(file.url)) {
  	// 		return setTimeout(download.bind(null, file.url), 100 * ++delay);
  	// 	}
    //
  	// 	download(file);
  	// });
  },
};



// WEBPACK FOOTER //
// ./src/app/utils/multi-download.js